// src/pages/IO/RecalculateData.tsx

import { ImportExportTwoTone } from '@mui/icons-material'
import {
  Alert,
  Avatar,
  Breadcrumbs,
  Button,
  TextField,
  Typography,
} from '@mui/material'
import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

import { SensorId } from '@/types/domain'

import {
  DlgRecalculateSensorData,
  HStack,
  KPage,
  Preloader,
} from '../../components'
import {
  OperatorData,
  useInsertMissingSensorData,
  useOperator,
  usePreviewMissingSensorData,
} from '../../hooks'

export const RecalculateData = () => {
  const { insertMissingSensorData } = useInsertMissingSensorData()
  const { fetchPreview, isLoading, isError, data, reset } =
    usePreviewMissingSensorData()
  const opData: OperatorData = useOperator()

  const dataStructure = {
    data: {
      first_sensor_message: {},
      missing_data: [],
      second_sensor_message: {},
    },
  }

  const [sId, setSId] = useState<SensorId>(null)
  const [entityId1, setEntityId1] = useState('')
  const [entityId2, setEntityId2] = useState('')
  const [timeStep, setTimeStep] = useState('')
  const [hasPreview, setHasPreview] = useState<boolean>(false)
  const [modal, setModal] = useState<boolean>(false)

  useEffect(() => {
    if (!data) return

    setHasPreview(true)
    setModal(true)
  }, [data])

  useEffect(() => setHasPreview(false), [sId, entityId1, entityId2, timeStep])

  const getPreview = () => {
    reset()
    fetchPreview(sId, entityId1, entityId2, timeStep)
  }

  const onStart = () => insertMissingSensorData((data || dataStructure).data)

  const onChangeSensorId = event => setSId(Number(event.target.value))
  const onChangeEntityId1 = event => setEntityId1(event.target.value)
  const onChangeEntityId2 = event => setEntityId2(event.target.value)
  const onChangeTimeStep = event => setTimeStep(event.target.value)

  const onClose = () => setModal(false)

  const previewEnabled: boolean =
    !isNaN(sId) && entityId1 !== '' && entityId2 !== '' && timeStep !== ''

  return opData?.isAdmin ? (
    <>
      <Preloader isLoading={isLoading} error={isError} />

      <KPage
        avatar={
          <Avatar>
            <ImportExportTwoTone />
          </Avatar>
        }
        title={
          <Breadcrumbs sx={{ mx: 1, my: 2 }}>
            <Link to={'/io'}>
              <Typography>Exporte</Typography>
            </Link>
            <Typography>Messdaten aktualisieren</Typography>
          </Breadcrumbs>
        }
      >
        <Typography variant={'h4'} sx={{ mx: 1, my: 2 }}>
          Messdaten aktualisieren
        </Typography>

        <TextField
          label={'Sensor ID'}
          onChange={onChangeSensorId}
          type={'number'}
          value={sId}
        />

        <TextField
          label={'Entity ID 1'}
          onChange={onChangeEntityId1}
          type={'number'}
          value={entityId1}
        />

        <TextField
          label={'Entity ID 2'}
          onChange={onChangeEntityId2}
          type={'number'}
          value={entityId2}
        />

        <TextField
          label={'Zeitintervall'}
          onChange={onChangeTimeStep}
          type={'number'}
          value={timeStep}
        />

        <HStack
          sx={{
            mx: 1,
            display: 'flex',
            gap: 1,
            my: 2,
            justifyContent: 'flex-end',
          }}
        >
          <Button disabled={!previewEnabled} onClick={getPreview}>
            Vorschau
          </Button>

          <Button disabled={!hasPreview} onClick={onStart}>
            Start
          </Button>
        </HStack>

        <DlgRecalculateSensorData
          onClose={onClose}
          open={modal}
          data={data || dataStructure}
        />
      </KPage>
    </>
  ) : (
    <Alert severity={'info'}>Admin Bereich</Alert>
  )
}
